import { render, staticRenderFns } from "./SubmissionFormInvoiceInfo.vue?vue&type=template&id=4fe92b5e&scoped=true&"
import script from "./SubmissionFormInvoiceInfo.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormInvoiceInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe92b5e",
  null
  
)

export default component.exports